import { useCallback, useState } from 'react'

/// 더보기버튼
export const useMoreButton = (initialIndex: number): any => {
  const [more, setMore] = useState(initialIndex)
  const handler = useCallback(() => {
    setMore((prevMore) => prevMore + 1)
  }, [])

  return [more, handler, setMore]
}
